<div class="cover-container" [class.has-asset]="gallery.cover.uuid" [style.--color-primary]="gallery.primary_color">
  <div
    class="cover size-{{ gallery.cover.uuid ? gallery.cover.size : 'none' }}"
    [class.content-left]="gallery.cover.content_position?.[0] === 0"
    [class.content-right]="gallery.cover.content_position?.[0] === 1"
    [class.content-top]="gallery.cover.content_position?.[1] === 0"
    [class.content-bottom]="gallery.cover.content_position?.[1] === 1"
    #cover
  >
    @if (gallery.cover?.uuid) {
      <div class="cover-asset" #el>
        @if (!gallery.cover.video_origin) {
          @if (
            !gallery.cover.video_origin && gallery.cover?.uuid
              | galleryCoverUrl
                : gallery.cover.width
                : gallery.cover.height
                : cover.clientWidth
                : cover.clientHeight
                : gallery.cover.ext
              | async;
            as coverSrc
          ) {
            <img [src]="coverSrc" alt="" [style.object-position]="gallery.cover.position" />
          }
        }
        @if (gallery.cover.video_origin) {
          <app-video-viewer
            [videoData]="$any(gallery.cover)"
            [uuid]="gallery.cover.video_origin | videoOrigin: 'uuid'"
            [origin]="gallery.cover.video_origin | videoOrigin: 'origin'"
            [poster]="
              gallery.cover?.uuid
                | galleryCoverUrl
                  : gallery.cover.width
                  : gallery.cover.height
                  : cover.clientWidth
                  : cover.clientHeight
                  : 'jpg'
                | async
            "
            [active]="true"
            [showUi]="false"
            [autoplay]="true"
            [muted]="true"
            [loop]="true"
            [cover]="true"
            [coverPosition]="gallery.cover.position"
            [targetWidth]="el.clientWidth"
          ></app-video-viewer>
        }
      </div>
    }
    @if (gallery.cover?.uuid) {
      <div class="cover-overlay" [style.backgroundColor]="gallery.cover?.overlay_color || 'transparent'"></div>
    }
    <div class="cover-content">
      @if (gallery.title) {
        <h1
          [style.color]="gallery.cover.title_typography?.font_color || gallery.default_title_typography?.font_color"
          [style.fontFamily]="
            (gallery.cover.title_typography?.font_family ||
              gallery.default_title_typography?.font_family ||
              tenant?.default_cover_title_typography?.font_family) + ', AkkuratLL'
          "
          class="{{ getFontSize(gallery.cover?.title_typography?.font_size) }}"
        >
          {{ gallery.title }}
        </h1>
      }
      @if (gallery.description) {
        <h3
          [style.color]="
            gallery.cover.paragraph_typography?.font_color || gallery.default_paragraph_typography?.font_color
          "
          [style.fontFamily]="
            (gallery.cover.paragraph_typography?.font_family ||
              gallery.default_paragraph_typography?.font_family ||
              tenant?.default_paragraph_typography?.font_family) + ', AkkuratLL'
          "
          class="{{ getFontSize(gallery.cover?.paragraph_typography?.font_size) }}"
          [innerHTML]="gallery.description"
        ></h3>
      }
    </div>
  </div>
</div>
